import { create } from '@thoughtspot/logger';
import _ from 'lodash';
import { validateVisualPropsEventPayloadObject } from './util';
const logger = create('RenderEvents');
const validateVisualPropEventPayload = (eventData, visualPropEditorDefinition, globalPersistedVisualPropKey) => {
    const payload = eventData.payload;
    try {
        if (payload.visualProps?.clientState &&
            !_.isString(payload.visualProps?.clientState)) {
            throw new Error('Invalid Type visualProps.clientState must be stringified');
        }
        if (!_.isString(payload.visualProps) &&
            globalPersistedVisualPropKey &&
            !_.isEmpty(globalPersistedVisualPropKey)) {
            globalPersistedVisualPropKey.forEach(key => {
                if (payload.visualProps[key] &&
                    !_.isString(payload.visualProps[key]))
                    throw new Error(`Invalid Type visualProps.${key} must be stringified`);
            });
        }
        validateVisualPropsEventPayloadObject(payload.visualProps, visualPropEditorDefinition);
    }
    catch (err) {
        logger.warn(err);
        return {
            isValid: false,
            errors: [err.toString()],
        };
    }
    return {
        isValid: true,
    };
};
const getVisualPropUpdateEventProcessor = (props) => {
    return {
        validateEventPayload: (eventData) => {
            return validateVisualPropEventPayload(eventData, props.visualPropEditorDefinition, props.globalPersistedKeyVisualProp);
        },
        executeEvent: (eventData) => {
            const payload = eventData.payload;
            props.updateVisualProps(payload.visualProps, payload.isSystemAction, props.visualPropEditorDefinition, props.globalPersistedKeyVisualProp);
            return Promise.resolve();
        },
    };
};
const testHooks = {
    validateVisualPropEventPayload,
};
export { testHooks, getVisualPropUpdateEventProcessor };
//# sourceMappingURL=index.js.map